import { Box, Flex, Icon, Input } from '@cowsquare/design';
import gql from 'graphql-tag';
import * as R from 'ramda';
import React from 'react';
import { Query } from 'react-apollo';
import { Helmet } from 'react-helmet';
import defaultCover from '../../../../asset/defaultCover.jpg';
import { getQueryObject } from '../../../../utils/getQueryObject';
import { useAdsQuery, usePagesBindingUrl } from '../../../../utils/hooks';
import { Advertisements } from '../../../Advertisements';
import { MedicalCardListLoading } from '../../../Loading';
import MedicalCardList from '../../../MedicalCardList';
import { Section } from '../../../Section';
import { Title } from '../../../Title';

const PAGE_SIZE = 21;

const GET_SUPPLIERS = gql`
  query getSuppliers($limit: Int, $offset: Int) {
    total: hkdutest_e_drug_suppliers_aggregate {
      aggregate {
        count
      }
    }

    list: hkdutest_e_drug_suppliers(limit: $limit, order_by: { name: desc }, offset: $offset) {
      id
      name
      fax
      email
      cover_id
      cover {
        link
        name
      }
      content
      address
      phone
      user {
        name
        email
      }
      website
    }
  }
`;

const List = ({ location, uri }) => {
  const queryObject = getQueryObject(location);
  const [page, onPageChange] = usePagesBindingUrl(queryObject, uri);
  const { ads } = useAdsQuery(uri);

  return (
    <Query
      query={GET_SUPPLIERS}
      variables={{
        limit: PAGE_SIZE,
        offset: (page - 1) * PAGE_SIZE,
      }}
    >
      {({ data, loading }) => {
        const list = R.propOr([], 'list', data);
        const total = R.pathOr(0, ['total', 'aggregate', 'count'], data);
        return (
          <Section>
            <Helmet>
              <title>Pharm Dir - HKDU E-Pharm</title>
            </Helmet>
            <Advertisements ads={ads} />
            <Box px={[5, 0]} pt={8}>
              <Box mb={6}>
                <Flex flexDirection={['column', 'row']} justifyContent="space-between">
                  <Title m={0} mb={[6, 0]}>
                    Pharm Dir
                  </Title>
                  <Box width={[1, '200px']}>
                    <Input placeholder="Search company name" suffix={<Icon name="SEARCH" />} />
                  </Box>
                </Flex>
              </Box>
              {R.and(R.isEmpty(list), loading) && <MedicalCardListLoading hasCover />}
              <MedicalCardList
                height="364px"
                cardData={list}
                defaultCover={defaultCover}
                total={total}
                uri={uri}
                page={page}
                onPageChange={onPageChange}
              />
            </Box>
          </Section>
        );
      }}
    </Query>
  );
};

export default List;
